/*
 * gramms LP1 — carousel controller.
 * Progressive enhancement over a scroll-snap track: without JS the strip is
 * still swipeable, the arrows simply never appear.
 */
(function () {
  var PAGE_EPSILON = 2;

  function setup(root) {
    if (!root || root.dataset.lp1CarouselReady === 'true') return;

    var viewport = root.querySelector('[data-lp1-carousel-viewport]');
    var track = root.querySelector('[data-lp1-carousel-track]');
    if (!viewport || !track) return;

    /* A section can expose more than one control set — the ingredients
       carousel has one pair beside the heading for desktop and another under
       the track for mobile — so every match has to be wired, not just the
       first one. */
    var prevButtons = root.querySelectorAll('[data-lp1-carousel-prev]');
    var nextButtons = root.querySelectorAll('[data-lp1-carousel-next]');
    var dots = root.querySelector('[data-lp1-carousel-dots]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    root.dataset.lp1CarouselReady = 'true';

    function pageCount() {
      return Math.max(1, Math.round(viewport.scrollWidth / viewport.clientWidth));
    }

    function currentPage() {
      return Math.round(viewport.scrollLeft / viewport.clientWidth);
    }

    function scrollToPage(index) {
      var last = pageCount() - 1;
      var target = Math.min(Math.max(index, 0), last);
      viewport.scrollTo({
        left: target * viewport.clientWidth,
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    }

    function renderDots() {
      if (!dots) return;
      var total = pageCount();

      if (dots.children.length !== total) {
        dots.textContent = '';
        for (var i = 0; i < total; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'lp1-carousel__dot';
          dot.dataset.page = String(i);
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + total);
          dots.appendChild(dot);
        }
      }

      var active = currentPage();
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    }

    function syncArrows() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      var atStart = viewport.scrollLeft <= PAGE_EPSILON;
      var atEnd = viewport.scrollLeft >= max - PAGE_EPSILON;
      Array.prototype.forEach.call(prevButtons, function (b) { b.disabled = atStart; });
      Array.prototype.forEach.call(nextButtons, function (b) { b.disabled = atEnd; });
    }

    function sync() {
      renderDots();
      syncArrows();
    }

    Array.prototype.forEach.call(prevButtons, function (button) {
      button.addEventListener('click', function () { scrollToPage(currentPage() - 1); });
    });
    Array.prototype.forEach.call(nextButtons, function (button) {
      button.addEventListener('click', function () { scrollToPage(currentPage() + 1); });
    });

    if (dots) {
      dots.addEventListener('click', function (event) {
        var target = event.target.closest('[data-page]');
        if (target) scrollToPage(Number(target.dataset.page));
      });
    }

    viewport.addEventListener('scroll', sync, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(viewport);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  }

  function setupAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-lp1-carousel]');
    Array.prototype.forEach.call(roots, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
